import { GetStaticPaths } from 'next'

import { makeGatePage } from '../../components/app-gate/gatePage'
import { gateStaticProps } from '../../components/app-gate/gateStaticProps'

// Rotas do app: /evaluation/me, /evaluation/evolution, /evaluation/compare/:uuid
export const getStaticPaths: GetStaticPaths = async () => ({
  paths: [{ params: { slug: [] } }],
  fallback: 'blocking',
})

export const getStaticProps = gateStaticProps

export default makeGatePage({ gateKey: 'evaluation', ticks: 3 })
